import * as actionTypes from './actionTypes';
import {getData, postData} from "../../shared/networkUtil";

export const createTransactionsRequest = () => ({
    type: actionTypes.CREATE_TRANSACTIONS_REQUEST
});

export const createTransactionsSuccess = data => ({
    type: actionTypes.CREATE_TRANSACTIONS_SUCCESS,
    data: data
});

export const createTransactionsFail = error => ({
    type: actionTypes.CREATE_TRANSACTIONS_FAIL,
    error: error
});

export const runTransactionsRequest = () => ({
    type: actionTypes.RUN_TRANSACTIONS_REQUEST
});

export const runTransactionsSuccess = data => ({
    type: actionTypes.RUN_TRANSACTIONS_SUCCESS,
    data: data
});

export const runTransactionsFail = error => ({
    type: actionTypes.RUN_TRANSACTIONS_FAIL,
    error: error
});

export const runBundleRequest = () => ({
    type: actionTypes.RUN_BUNDLE_REQUEST
});

export const runBundleSuccess = data => ({
    type: actionTypes.RUN_BUNDLE_SUCCESS,
    data: data
});

export const runBundleError = error => ({
    type: actionTypes.RUN_BUNDLE_ERROR,
    error: error
});

export const addPaymentMethodRequest = () => ({
    type: actionTypes.ADD_PAYMENT_METHOD_REQUEST
});

export const addPaymentMethodSuccess = data => ({
    type: actionTypes.ADD_PAYMENT_METHOD_SUCCESS,
    data: data
});

export const addPaymentMethodFail = error => ({
    type: actionTypes.ADD_PAYMENT_METHOD_FAIL,
    error: error
});

export const clearTransactions = () => ({
    type: actionTypes.CLEAR_TRANSACTIONS
});

export const createPaymentIntentStart = () => ({
    type: actionTypes.CREATE_PAYMENT_INTENT_START
});

export const createPaymentIntentSuccess = paymentIntent => ({
    type: actionTypes.CREATE_PAYMENT_INTENT_SUCCESS,
    data: paymentIntent
});

export const createPaymentIntentError = error => ({
    type: actionTypes.CREATE_PAYMENT_INTENT_ERROR,
    error: error
});


const runTransactions = (transactionIds) => dispatch => {
    dispatch(runTransactionsRequest());
    postData(
        "/transactions/cart/run?" + transactionIds.map(t => 'ids=' + t).join("&"),
        null,
        result => {
            dispatch(runTransactionsSuccess(result.data))
        },
        error => {
            console.log('runTransactionError', error);
            dispatch(runTransactionsFail(error))
        }
    )
};

const runBundleTransaction = cuId => dispatch => {
    dispatch(runBundleRequest());
    postData(
        "/transactions/contract/" + cuId,
        null,
        result => {
            console.log(result);
            dispatch(runBundleSuccess(result.data))
        },
        error => {
            console.log('runBundleError', error);
            dispatch(runBundleError(error))
        }
    )
};
export const addPaymentMethod = (transactionId, paymentMethod) => dispatch => {
    dispatch(addPaymentMethodRequest());
    postData(
        "/transactions/run/" + transactionId + "/intent/" + paymentMethod,
        {},
        result => {
            dispatch(addPaymentMethodSuccess(result.data));
        },
        error => {
            console.log("error", error);
            dispatch(addPaymentMethodFail(error))
        }
    )
};
export const addPaymentMethodAndBuy = (customerId, token, expiry, cvv, cartItems, postal) => dispatch => {
    console.log("tx start add and buy");
    dispatch(addPaymentMethodRequest());
    const body = {
        customerId: customerId,
        token: token,
        expiry: expiry,
        cvv: cvv,
        cartItems: cartItems,
        postal: postal
    }
    postData(
        "/transactions/giftcards",
        body,
        result => {
            console.log("result", result);
            dispatch(addPaymentMethodSuccess(result.data))
            dispatch(runTransactionsSuccess(result.data))

        },
        error => {
            console.log("error", error);
            dispatch(addPaymentMethodFail(error))
        }
    )
};


export const createPaymentIntent = (transaction) => dispatch => {
    dispatch(createPaymentIntentStart());
    postData(
        "/transactions/intent/" + transaction,
        {},
        response => {
            console.log('response', response);
            dispatch(createPaymentIntentSuccess(response.data));
        },
        error => {
            console.log(error);
            dispatch(createPaymentIntentError());
        }
    )

};

export const addPaymentMethodAndBuyOrderForm = (userId, token, provider, transactionIds) => dispatch => {
    dispatch(addPaymentMethodRequest());
    postData(
        "/users/" + userId + "/nonce/" + token + "?provider=" + provider,
        {},
        result => {
            console.log("result", result);
            dispatch(addPaymentMethodSuccess());
            dispatch(runTransactions(transactionIds));
        },
        error => {
            console.log("error", error);
            dispatch(addPaymentMethodFail(error));
        }
    )
};

export const getUserIdFromCuidRequest = () => ({
    type: actionTypes.GET_USER_ID_FROM_CUID_REQUEST
});

export const getUserIdFromCuidSuccess = (id, cuId) => ({
    type: actionTypes.GET_USER_ID_FROM_CUID_SUCCESS,
    id: id,
    cuId: cuId
});

export const getUserIdFromCuidError = error => ({
    type: actionTypes.GET_USER_ID_FROM_CUID_ERROR,
    error
});

export const getUserIdFromCuid = cuId => dispatch => {
    dispatch(getUserIdFromCuidRequest());
    getData(
        "/adobesign/user/" + cuId,
        result => {
            console.log('cuId success', result);
            dispatch(getUserIdFromCuidSuccess(result.data.id, cuId))
        },
        error => {
            console.log('cuid error', error);
            dispatch(getUserIdFromCuidError(error))
        }
    )
};

export const resetUserIdAndCuId = () => ({
    type: actionTypes.RESET_USER_ID_AND_CUID,
});

export const addPaymentMethodAndBuyBundle = (token, provider, userId, cuId) => dispatch => {
    dispatch(addPaymentMethodRequest());
    postData(
        "/users/" + userId + "/nonce/" + token + "?provider=" + provider,
        {},
        result => {
            console.log("bundle result", result);
            dispatch(addPaymentMethodSuccess());
            dispatch(runBundleTransaction(cuId));
        },
        error => {
            console.log("error", error);
            dispatch(addPaymentMethodFail(error))
        }
    )
};
